import React, { useRef } from 'react'
import PropTypes from 'prop-types'

import styles from './overlay.module.scss'
import { useConditionalEventHandler } from 'app/hooks/useEventHandler'

const Overlay = ({ isOpen, openChange, children, includeRefs, className = '', ...rest }) => {
  // TODO : pass in connected element - adjust position on screen
  const containerRef = useRef()

  const closeOverlay = (e) => {
    if (containerRef.current?.contains(e.toElement)) {
      return
    }

    const keepOpen = includeRefs?.some((ref) => {
      return ref.current === e.target || ref.current?.contains(e.target)
    })

    if (keepOpen) {
      return
    }

    if (typeof openChange === 'function') {
      openChange(false)
    }
  }

  const closeOverlayRef = useRef(closeOverlay)

  useConditionalEventHandler(isOpen, 'click', closeOverlayRef.current)
  useConditionalEventHandler(isOpen, 'keyup.Escape', closeOverlayRef.current)

  return (
    <>
      {isOpen && (
        <div className={`${styles.overlay} ${className}`} ref={containerRef} {...rest}>
          {children}
        </div>
      )}
    </>
  )
}

Overlay.propTypes = {
  isOpen: PropTypes.bool,
  openChange: PropTypes.func,
  className: PropTypes.string,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
    PropTypes.string,
  ]),
  includeRefs: PropTypes.arrayOf(
    PropTypes.oneOfType([
      PropTypes.any,
      PropTypes.func,
      PropTypes.shape({ current: PropTypes.oneOf([PropTypes.elementType, null]) }),
    ])
  ),
}

export { Overlay }
